// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"styles-module--fadeIn--3fFHS","pulse":"styles-module--pulse--2CW6k","slideInDown":"styles-module--slideInDown--3ur_C"};